import React from "react";
import classNames from "classnames";
import Switch from "react-switch";

import "./Switch.scss";

const classNamePrefix = "Switch";

type CustomSwitchProps = React.FormHTMLAttributes<HTMLFormElement> & {
  onChange: (checked: boolean) => void;
  checked: boolean;
  label: string;
  description?: string;
};

export const CustomSwitch = React.forwardRef(
  (props: SwitchProps, ref?: React.ForwardedRef<HTMLFormElement>) => {
    const { onChange, checked, label, description } = props;
    return (
      <div className={`${classNamePrefix}`}>
        <div>
          <label>
            <strong>{label}</strong>
          </label>
          <p>{description}</p>
        </div>
        <div className={`${classNamePrefix}-toggle`}>
          <span className={`${classNamePrefix}-toggle-label`}>Non</span>
          <Switch
            onChange={onChange}
            checked={checked}
            offColor="#888"
            onColor="#002FA6"
            width={40}
            height={20}
            handleDiameter={10}
            uncheckedIcon={false}
            checkedIcon={false}
          />
          <span className={`${classNamePrefix}-toggle-label`}>Oui</span>
        </div>
      </div>
    );
  },
);
